import { Geocode2, ImageDimensionsModel, PhotoAnalysis, PhotoArea } from "interfaces/Mueller.Business.Models";

export const PhotoDownloadNamingConventions = {
  DEFAULT_PHOTO_NAMING: "default",
  PHOTO_TAG_NAMING: "tagname",
};

export const photoEditOperationTypes = {
  BRIGHTNESS: 1,
  ROTATE: 2,
  CROP: 3,
};

export interface PhotoEdit {
  Operation: 1 | 2 | 3;
  Parameter: string | number;
}

export interface PhotoEditOptions {
  Edits: PhotoEdit[];
}

//The model made by generating the business models for PhotoProperties has all of the props lowercase, but these need to be uppercase when sending to the photos svc
export interface PhotoPropertiesPhotoSvc {
  Id: string;
  BucketUri: string | undefined;
  Geocode: Geocode2 | undefined;
  Tags: string[] | undefined;
  SortOrder: number;
  UserDescription: string | undefined;
  CaptureDate: Date | string | undefined;
  OwnerUsername: string | undefined;
  LastModifiedDate: Date | string | undefined;
  LastViewedDate: Date | string | undefined;
  PhotoAreas: PhotoArea[] | undefined;
  FileSizeBytes: number;
  ImageDimensions: ImageDimensionsModel | undefined;
  UploadedDate: Date | string | undefined;
  Analysis: PhotoAnalysis | undefined;
}

export const PHOTOS_BROADCAST_CHANNEL_NAME = "photos_tool";
export const PHOTOS_BROADCAST_PHOTO_EDITED_TYPE = "photo-edited";
export const PHOTOS_BROADCAST_RELOAD_PHOTOS = "reload-photos";
export const PHOTOS_BROADCAST_SAVE_PHOENIX_FORMS = "save-phoenix-forms";
export const PHOTOS_BROADCAST_CREATE_PHOENIX_FORMS_SAVE_SUBSCRIPTION = "create-phoenix-forms-save-subscription";
